import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

// import Users from "./user/pages/Users";
// import NewPlace from "./places/pages/NewPlace";
// import UserPlaces from "./places/pages/UserPlaces";
// import UpdatePlace from "./places/pages/UpdatePlace/UpdatePlace";
import MainNavigation from "./shared/components/Navigation/MainNavigation/MainNavigation";
// import Authenticate from "./user/pages/Authenticate/Authenticate";
import { AuthContext } from "./shared/context/auth-context";
import { useAuth } from "./shared/hooks/auth-hook";
import LoadingSpinner from "./shared/components/UIElements/LoadingSpinner/LoadingSpinner";
import LandingPage from "./places/components/LandingPage/LandingPage";
import Footer from "./layout/Footer/Footer";

const Users = React.lazy(() => import("./user/pages/Users"));
const Places = React.lazy(() => import("./places/pages/Places"));
const NewPlace = React.lazy(() => import("./places/pages/NewPlace"));
const UserPlaces = React.lazy(() => import("./places/pages/UserPlaces"));
const UpdatePlace = React.lazy(() =>
  import("./places/pages/UpdatePlace/UpdatePlace")
);
const Authenticate = React.lazy(() =>
  import("./user/pages/Authenticate/Authenticate")
);

const App = () => {
  const { token, login, logout, userId } = useAuth();
  let routes;

  if (token) {
    routes = (
      <Switch>
        <Route exact path="/">
          <LandingPage />
        </Route>
        <Route exact path="/users">
          <Users />
        </Route>
        <Route exact path="/places">
          <Places />
        </Route>
        <Route exact path="/:userId/places">
          <UserPlaces />
        </Route>
        <Route exact path="/places/new">
          <NewPlace />
        </Route>
        <Route exact path="/places/:placeId">
          <UpdatePlace />
        </Route>
        <Redirect to="/" />
      </Switch>
    );
  } else {
    routes = (
      <Switch>
        <Route exact path="/">
          <LandingPage />
        </Route>
        <Route exact path="/users">
          <Users />
        </Route>
        <Route exact path="/places">
          <Places />
        </Route>
        <Route exact path="/:userId/places">
          <UserPlaces />
        </Route>
        <Route exact path="/auth">
          <Authenticate />
        </Route>
        <Redirect to="/auth" />
      </Switch>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout,
      }}
    >
      <Router>
        <MainNavigation />
        <main>
          <Suspense
            fallback={
              <div className="center">
                <LoadingSpinner />
              </div>
            }
          >
            {routes}
          </Suspense>
        </main>
        <Footer />
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
